import { render, staticRenderFns } from "./ChatBoxQRCode.vue?vue&type=template&id=510af804&scoped=true"
import script from "./ChatBoxQRCode.vue?vue&type=script&lang=js"
export * from "./ChatBoxQRCode.vue?vue&type=script&lang=js"
import style0 from "./ChatBoxQRCode.vue?vue&type=style&index=0&id=510af804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510af804",
  null
  
)

export default component.exports